import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@restworld/utils-common';
import { useRestaurantsService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

function useEmployerRestaurantNamesQuery(staleTime = Infinity) {
  const restaurantsService = useRestaurantsService();
  const { user } = useAuth();
  const organizationId = user?.organization_id;
  const queryKey = useEmployerRestaurantNamesQueryKey();

  const query = useQuery({
    queryKey,
    queryFn: () => restaurantsService.fetchRestaurantNames({ organization_id: organizationId }),
    select: (data) => data?.data,
    enabled: !!organizationId,
    // Refetch every time component mounts
    staleTime: 0,
    gcTime: 0,
  });

  return query;
}
export default useEmployerRestaurantNamesQuery;

export function useEmployerRestaurantNamesQueryKey() {
  const { user } = useAuth();
  const organizationId = user?.organization_id;

  return [QUERY_KEYS.RESTAURANTS.NAMES, organizationId];
}
